import { RefObject, useLayoutEffect, useRef, useState } from 'react';
interface OverflowX {
  ref: RefObject<HTMLDivElement>;
  isOverflowX: boolean;
}

/**
 * Hook to check if an element has overflow-x
 */
export const useOverflowX = (): OverflowX => {
  const [isOverflowX, setIsOverflowX] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  // Helper ref to ensure isOverflowX gets updated with the change of layout
  const isOverflowXRef = useRef<boolean>(false);

  useLayoutEffect(() => {
    const { current } = ref;

    const resizeObserver = new ResizeObserver(() => {
      if (current) {
        const hasOverflowX = current.scrollWidth > current.clientWidth;
        if (hasOverflowX !== isOverflowXRef.current) {
          setIsOverflowX(hasOverflowX);
          isOverflowXRef.current = hasOverflowX;
        }
      }
    });

    if (current) {
      resizeObserver.observe(current);
      const hasOverflowX = current.scrollWidth > current.clientWidth;
      if (hasOverflowX !== isOverflowXRef.current) {
        setIsOverflowX(hasOverflowX);
        isOverflowXRef.current = hasOverflowX;
      }
    }

    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  return { ref, isOverflowX };
};
